import { CONNECT_INFO } from "pages/system-monitor/components/const";
import apiManagerRoom from "../../api/manager-meeting";
import { toastSuccess, toastWarning } from "utils/helpers";
import { DOMAIN_MEETING, VTCLOUD_MARKETPLACE, URL_LANDING_PAGE } from "constants/api";
import apiManagerSystem from "api/manager-systems";
import { CONFIG_SYSTEM_CODE } from "constants/common";
import store from "store/store";
import { setCloseCurrentDialog } from "store/dialogSlice";

const converIdMeet = (id) => {
    return id.slice(0, 3) + ' ' + id.slice(3, 6) + ' ' + id.slice(6, id.length);
};

const handleJoinMeetByVMP = (meetingCurrent, timeSearch, moment, t) => {
    // Check if the meeting can be started yet -> current moment must be between start and end time of meeting

    if (meetingCurrent.isInstant !== 1) {
        if (meetingCurrent.isPeriod === "yes") {
            if (moment(meetingCurrent.start) < moment() && moment() < moment(meetingCurrent.end)) {
                apiManagerRoom.getRoomByType("not_start-progress", { start: timeSearch.start, end: timeSearch.end, page: null })
                    .then((r) => {
                        let findRoomWithId = r?.data?.records?.filter(
                            record => record?.roomId === meetingCurrent.roomId
                        );
                        // Check meeting that already ended or already start
                        if (findRoomWithId[0]?.type === "not_start") window.open(`${meetingCurrent.link}`);
                        else if (findRoomWithId.length === 0) toastWarning(t('toast.meetingAreadyEnded'))
                        else toastWarning(t('toast.meetingAreadyStarted'))
                    })
                    .catch((error) => {
                    })
            } else toastWarning(t('toast.notYetTimeToJoin'))
        } else window.open(`${meetingCurrent.link}`);
    } else window.open(`${meetingCurrent.link}`);
};

const copyToClipboard = (e, t) => {
    navigator.clipboard.writeText(e);
    toastSuccess(t('toast.copied'));
};

const stringAvatar = (name, userInfo, unsize = false, sx ={}, width = '168px', height = '168px', fontSize = '84px') => {
    let nameConvertArr = name?.split(" ");
    let upperCaseName = name?.toUpperCase();
    let renderName;
    if (nameConvertArr?.length >= 2) {
        renderName = upperCaseName?.split(' ')[nameConvertArr?.length - 2][0] + upperCaseName?.split(' ')[nameConvertArr?.length - 1][0]
    } else {
        renderName = upperCaseName?.split(' ')[0][0]
    }

    return unsize ? 
    {
        sx: {
            bgcolor: userInfo?.bgrColor,
            ...sx
        },
        children: renderName
    } : 
    {
        sx: {
            bgcolor: userInfo?.bgrColor,
            width,
            height,
            fontSize,
            ...sx
        },
        children: renderName,
    };
}

const convertDataUserSip = (data) => {
    if(data?.length) {
        const _data = data?.map(d => {
            if(d.user.length > 0) {
    
                let userShare = ''
    
                d.user.forEach((s, ind) => {
                    userShare += s.username
                    if(ind === d.user.length - 1) {
                        userShare += ''
                    } else userShare += ', '
                });
    
                return {
                    ...d,
                    userShare: userShare
                }
            }
    
            return {
                ...d,
                userShare: ''
            }
        })
    
        return _data
    }

    return []
}

const convertRoleInRoom = (role, t) => {
    switch (role) {
        case 'owner': 
            return t("modalDetail.roleUser.owner")
        case 'host':
            return t("modalDetail.roleUser.host")
        case 'coHost':
            return t('modalDetail.roleUser.coHost')
        case 'participant':
            return t('modalDetail.roleUser.participant')
        default:
            return t('modalDetail.roleUser.guest')
    }
}

const convertConnection = (number) => {
    if(+number < 10) {
        return CONNECT_INFO.LOSS.NAME
    } else if(+number < 30) {
        return CONNECT_INFO.POOR.NAME
    } else if(+number < 50) {
        return CONNECT_INFO.NONOPTIMAL.NAME
    } else {
        return CONNECT_INFO.GOOD.NAME
    }
}

const localLog = function () {
    const LIST_MODE = ['debugger', 'DEBUGGER']
    const MODE = LIST_MODE.includes(localStorage.getItem('mode'))
    if(MODE) {
        console.log.apply(console, arguments)
    }
}

/**
 * Đi tới landingpage
 */
export function goToLandingPage() {
    window.open(URL_LANDING_PAGE, '_blank')
}

export function goToLicenseStore() {
    window.open(VTCLOUD_MARKETPLACE, '_blank')
}

/**
 * 
 * @param {*} roomId 
 */
export function joinRoomByRoomId(roomId) {
    window.open(`${DOMAIN_MEETING}/${roomId}`)
}

/**
 * Đi tới trang thông tin theo config hệ thống hoặc landingpage
 */
export async function goToInfoPage() {
    try {
        const res = await apiManagerSystem.getOneConfig(CONFIG_SYSTEM_CODE.PAGE_INFO)
        if(res?.data[0]?.value) window.location.href = res?.data[0]?.value
        else goToLandingPage()
    } catch (err) {
        console.log("ERR: ", err);
    }
}

export function goToRoomMeeting(roomId) {
    if(!roomId) return
    return window.open(`${DOMAIN_MEETING}/${roomId}`)
}

export function handleEnterKeyFunc(e, func) {
    if (e?.key === 'Enter') {
        func();
    }
}

export function closeCurrentDialog() {
    store.dispatch(setCloseCurrentDialog())
}

function stringName(name) {
    let nameConvertArr = name?.split(" ");
    let upperCaseName = name?.toUpperCase();
    let renderName;
    if (nameConvertArr?.length >= 2) {
        renderName = upperCaseName?.split(' ')[nameConvertArr?.length - 2][0] + upperCaseName?.split(' ')[nameConvertArr?.length - 1][0]
    } else {
        renderName = upperCaseName?.split(' ')[0][0];
    }
    return renderName;
}

export function randomColorFunc() {
    const rangeSize = 120;

    const rand = new Uint32Array(4);
    crypto.getRandomValues(rand);

    const parts = [
        rand[0] % 256,
        rand[1] % rangeSize,
        (rand[2] % rangeSize) + 256 - rangeSize
    ];

    for (let i = parts.length - 1; i > 0; i--) {
        const j = rand[3] % (i + 1);
        [parts[i], parts[j]] = [parts[j], parts[i]];
    }

    return parts
        .map(p => p.toString(16).padStart(2, '0'))
        .join('');
}

export function createRandomPassword() {
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const number = '0123456789';
    const special = '!@#$%^&*';

    const all = upper + lower + number + special;
    const result = [];

    const rand = new Uint32Array(12);
    crypto.getRandomValues(rand);

    result.push(upper[rand[0] % upper.length]);
    result.push(upper[rand[1] % upper.length]);

    result.push(lower[rand[2] % lower.length]);
    result.push(lower[rand[3] % lower.length]);

    result.push(special[rand[4] % special.length]);

    for (let i = 5; i < 8; i++) {
        result.push(all[rand[i] % all.length]);
    }

    for (let i = result.length - 1; i > 0; i--) {
        const j = rand[i] % (i + 1);
        [result[i], result[j]] = [result[j], result[i]];
    }

    return result.join('');
}


export { converIdMeet, convertDataUserSip, copyToClipboard, handleJoinMeetByVMP, stringAvatar, convertRoleInRoom, convertConnection, localLog, stringName };
